export default __webpack_public_path__ + "static/media/500.6e208a63.svg";